import React from 'react';
import '../less/item.less';
import computeIcon from '../utils/computeIcon.u';
import Details from '../views/itemDetails.c';
import {AnimateHeight} from '@ab/components';
import cx from 'classnames';
import {getCurrencySymbol} from '../../../constants/currency';
import InvoiceImg from '../img/invoice.svg';
import categoryImg from '../img/category/8.svg';
import Cancel from '../img/cancel.svg';

export default function template() {
    const {model, settings} = this.props,
        {active} = this.state,
        rest = model.balance.available;

    let details = null;

    if (active) {
        details = <Details {...this.props} />;
    }

    return (
        <div>
            <div className="module-statements-item" onClick={this.toggle}>
                <div className="category">
                    <img className="category-icon" src={categoryImg} />
                    {model.flags.receipt_available ? (
                        <img className="invoice-img" src={InvoiceImg} alt="invoice" />
                    ) : null}
                    {parseInt(model.response) > 1 ? (
                        <img className="invoice-img" src={Cancel} alt="cancel" />
                    ) : null}
                </div>
                <div className="description">
                    <div>
                        {parseInt(model.response) > 1
                            ? this.l10n('STATEMENTS_CANCEL') + model.purpose_reject
                            : model.purpose}
                    </div>
                </div>
                <div className="amount">
                    <div className={`amount-value ${model.type === 'DEBIT' ? 'debit' : 'credit'}`}>
                        <span>
                            {this.checkLastSymbolOfAmount(model.account_amount.value.toString())}
                        </span>
                        &nbsp;
                        <span>{getCurrencySymbol(parseInt(model.account_amount.currency))}</span>
                    </div>
                    <div className="date">
                        <span>{model.date_time}</span>
                    </div>
                </div>
                <div className={cx('rest', {negative: rest < 0})}>
                    <span>{this.checkLastSymbolOfAmount(rest.toString())}</span>
                    &nbsp;
                    <span>{getCurrencySymbol(parseInt(model.account_amount.currency))}</span>
                </div>
            </div>
            <AnimateHeight>{details}</AnimateHeight>
        </div>
    );
}
